/**
 * @desc 查询年计划列表
 */

import * as defs from '../../baseClass';
import { defHttp } from 'hailuo-http';
export interface Params {}

export function request(
  data: defs.PlanYearQueryRequest,
): Promise<defs.StandardReturn<defs.Pager<defs.PlanYearResponse>>> {
  return defHttp.post({
    url: '/web/plan/year/query',
    data,
  });
}

export function mock(
  data: defs.PlanYearQueryRequest,
): Promise<defs.StandardReturn<defs.Pager<defs.PlanYearResponse>>> {
  return defHttp.post({
    url: '/mock/web/plan/year/query',
    data,
  });
}
